import L from 'leaflet'
// import 'leaflet-edgebuffer'
/*

(function () {
  var originalInitTile = L.GridLayer.prototype._initTile
  L.GridLayer.include({
    _initTile: function (tile) {
      originalInitTile.call(this, tile)

      var tileSize = this.getTileSize()

      tile.style.width = tileSize.x + 1 + 'px'
      tile.style.height = tileSize.y + 1 + 'px'
    }
  })
})()

*/

(function () {
  const originalInitTile = L.GridLayer.prototype._initTile
  L.GridLayer.include({
    _initTile: function (tile) {
      originalInitTile.call(this, tile)

      const tileSize = this.getTileSize()
      const map = this._map
      const isFix = () => !(parseFloat(tile.style.width) % 0 === 0)
      const fixOn = () => {
        if (!isFix()) {
          return
        }
        tile.style.width = tileSize.x + 0.5 + 'px'
        tile.style.height = tileSize.y + 0.5 + 'px'
      }
      const fixOff = () => {
        if (isFix()) {
          return
        }
        tile.style.width = tileSize.x + 'px'
        tile.style.height = tileSize.y + 'px'
      }
      const checkFix = () => {
        const zoom = map.getZoom()
        if (zoom % 1 === 0) {
          fixOff()
        } else {
          fixOn()
        }
      }
      map.on('zoomstart', fixOn)
      map.on('zoomend', checkFix)
      checkFix()
    }
  })
})()

export { L }
